<template>
  <div class="component-app-qrcode">
    <div class="rounded border border-solid bm-bd-gray-200">
      <div class="p-1 bm-size-0 flex justify-center">
        <VueQrcode :value="qrcodeSrc" :options="{ margin: 0, width: 160 }" />
      </div>
      <div class="flex bm-row bm-row-cols-2 bm-gx-0 h-8 border-0 border-t border-solid bm-bd-gray-200">
        <span class="icon flex justify-center items-center">
          <Icon
class="svgfont"
mode="svg"
:size="19"
name="icon-bmui-navigator-app-apple"
        /></span>
        <span class="icon flex justify-center items-center">
          <Icon
class="svgfont"
mode="svg"
:size="19"
name="icon-bmui-navigator-app-android"
        /></span>
      </div>
    </div>
    <div class="mt-2 text-center text-sm leading-5" v-if="!hiddenDesc">
      <div>{{ $t('bmui-navigator-bar.common_app_download_desc') }}</div>
      <div class="font-medium">{{ $t('bmui-navigator-bar.common_app_download_desc2') }}</div>
    </div>
  </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import commonMixins from '../mixins';
import Icon from './Icon';
import { usePatchStore } from '~/common/js/patch';
// @TODO 重构这里
const breakDownHostUrl = (url) => {
  let hostUrl = url;
  let newUrl = hostUrl;
  // 防止未做301跳转，产生XXX.XXX的域名
  if (hostUrl.split('.') && hostUrl.split('.').length <= 2) {
    newUrl = hostUrl;
  } else {
    let number = hostUrl.indexOf('.');
    newUrl = hostUrl.slice(number + 1);
  }
  return newUrl;
};

export default {
  name: 'ComponentAppQRCode',
  components: {
    VueQrcode,
    Icon,
  },

  mixins: [commonMixins],
  props: {
    hiddenDesc: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    locale() {
      return this.store.locale;
    },
    qrcodeSrc() {
      if (process.client) {
        const host = breakDownHostUrl(window.location.host);
        return `https://h5.${host}/env/${this.locale}`;
      } else {
        return '';
      }
    },
  },

  methods: {},
  setup() {
    const { store } = usePatchStore();
    return {
      store,
    };
  }
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';

.component-app-qrcode {
  width: 180px;
  * {
    box-sizing: border-box;
  }

  .icon {
    position: relative;

    &:last-of-type {
      &:after {
        display: none;
      }
    }

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 1px;
      height: 16px;
      background-color: @gray_color_200;
    }
  }
}
</style>
